import React from 'react';
import * as Sentry from '@sentry/react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import './index.css';
import AppWrapper from './App';
import reportWebVitals from './reportWebVitals';
import {Capacitor} from '@capacitor/core';
import {StatusBar, Style} from '@capacitor/status-bar';
import {NavigationBar} from '@capgo/capacitor-navigation-bar';

// ── Sentry — monitorización de errores en producción ─────────────────
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,
    enabled: process.env.NODE_ENV === 'production',
  });
}

// ── Validación de variables de entorno críticas ──────────────────────
const REQUIRED_ENV = [
  'REACT_APP_ALGOLIA_APP_ID',
  'REACT_APP_ALGOLIA_RECIPES_INDEX',
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_PROJECT_ID',
];
const missingEnv = REQUIRED_ENV.filter(k => !process.env[k]);
if (missingEnv.length > 0) {
  // En producción logamos el error; en desarrollo mostramos un aviso claro
  console.error(
    '[CookyChat] Variables de entorno faltantes:',
    missingEnv.join(', '),
    '\nCopia .env.example a .env.local y rellena los valores.'
  );
  if (process.env.NODE_ENV === 'development') {
    document.body.innerHTML = `
      <div style="font-family:monospace;padding:32px;color:#c00">
        <h2>⚠️ Variables de entorno faltantes</h2>
        <pre>${missingEnv.join('\n')}</pre>
        <p>Copia <code>.env.example</code> a <code>.env.local</code> y rellena los valores.</p>
      </div>`;
  }
}

const container = document.getElementById('root');
const root = createRoot(container);

if (Capacitor.isNativePlatform()) {
  document.body.classList.add(Capacitor.getPlatform());
}

if (Capacitor.getPlatform() === 'android') {
  document.body.classList.add('android');
  StatusBar.setOverlaysWebView({overlay: false}).catch(() => {});
  StatusBar.setBackgroundColor({color: '#4e7d3a'}).catch(() => {});
  StatusBar.setStyle({style: Style.Light}).catch(() => {}); // Esto pone la fuente en blanco
  NavigationBar.setBackgroundColor({color: '#E3F2D0'}).catch(() => {});
  NavigationBar.setButtonStyle({style: 'Light'}).catch(() => {});
}

// Fix de 100vh en móviles
const setRealVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
setRealVh();
window.addEventListener('resize', setRealVh);
window.addEventListener('orientationchange', setRealVh);

root.render(
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Routes>
      <Route path="*" element={<AppWrapper />} />
    </Routes>
  </Router>
);

reportWebVitals();
